import type { SourceTarget } from "../model/types.js";

export function classLocationKey(internalName: string): string {
  return `class:${internalName}`;
}

export function fieldLocationKey(
  internalName: string,
  name: string,
  descriptor: string,
): string {
  return `field:${internalName}:${name}:${descriptor}`;
}

export function constructorLocationKey(
  internalName: string,
  descriptor: string,
): string {
  return `constructor:${internalName}:${descriptor}`;
}

export function methodLocationKey(
  internalName: string,
  name: string,
  descriptor: string,
): string {
  return `method:${internalName}:${name}:${descriptor}`;
}

export function sourceTargetLocationKey(target: SourceTarget): string {
  switch (target.kind) {
    case "class":
      return classLocationKey(target.internalName);
    case "field":
      return fieldLocationKey(
        target.internalName,
        target.name,
        target.descriptor,
      );
    case "constructor":
      return constructorLocationKey(target.internalName, target.descriptor);
    case "method":
      return methodLocationKey(
        target.internalName,
        target.name,
        target.descriptor,
      );
  }
}
